import axios from '@/libs/api.request.js'

// 获取首页数据
export const getNewsHomeData = (id) => {
  return axios.request({
    url: '/News/GetHomeData',
    params: { id },
    method: 'get'
  })
}

export const getPageList = (page, pageSize, data) => {
  return axios.request({
    url: '/News/GetPageList',
    params: {
      page,
      pageSize
    },
    data,
    method: 'post'
  })
}

//GetCertificateInfo
export const GetCertificateInfo = (data) => {
  return axios.request({
    url: '/News/GetCertificateInfo',
    data,
    method: 'post'
  })
}

// GetBaDaYuanCertificateInfo
export const GetBaDaYuanCertificateInfo = (data) => {
  return axios.request({
    url: '/News/GetBaDaYuanCertificateInfo',
    data,
    method: 'post'
  })
}


export const getDetail = (id) => {
  return axios.request({
    url: '/News/GetDetail',
    params: { id },
    method: 'get'
  })
}

export const GetTongGuo = (params) => {
  return axios.request({
    url: '/News/GetTongGuo',
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/news.js